import React from "react";
import { Link, useLocation } from "react-router-dom";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import BarChartIcon from "@mui/icons-material/BarChart";
import NotesIcon from "@mui/icons-material/Notes";
import SellIcon from "@mui/icons-material/Sell";
import CodeIcon from "@mui/icons-material/Code";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import ParkIcon from "@mui/icons-material/Park";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import ApprovalIcon from "@mui/icons-material/Approval";
import GamesIcon from "@mui/icons-material/Games";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import MessageIcon from "@mui/icons-material/Message";
import PhyishingIcon from "@mui/icons-material/Phishing";
import KeyIcon from "@mui/icons-material/Key";
import DownloadIcon from "@mui/icons-material/Download";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

import NavItem from "./NavItem";

export default function NestedList() {
  const location = useLocation();

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      sx={{ width: "100%", maxWidth: 360 }}
    >
      <Link to={"/dashboard"} key={0} style={{ textDecoration: "none" }}>
        <ListItemButton
          sx={{
            backgroundColor:
              location.pathname === "/dashboard" ? "#9c27b0" : "",
            "&:hover": {
              backgroundColor:
                location.pathname === "/dashboard" ? "#9c27b0" : "",
            },
          }}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText
            primary="Dashboard"
            sx={{
              fontSize: 14,
              lineHeight: "24px",
              letterSpacing: "0.02em",
              color: "#f0f0f0",
            }}
          />
        </ListItemButton>
      </Link>

      <NavItem
        label="Users"
        icon={<PersonIcon />}
        level1Labels={["View", "Add"]}
        level1Icons={[<VisibilityIcon />, <AddIcon />]}
        level1Links={["/users", "/register_new_user"]}
      />
      <NavItem
        label="Orgs"
        icon={<GroupsIcon />}
        level1Labels={["View", "Add"]}
        level1Icons={[<VisibilityIcon />, <AddIcon />]}
        level1Links={["/orgs", "/add_org"]}
      />
      <NavItem
        label="Reports"
        icon={<BarChartIcon />}
        level1Labels={["RiskTree", "Barkprints"]}
        level1Icons={[<ParkIcon />, <FingerprintIcon />]}
        level1Links={["/reports", "/barkprints"]}
      />
      <NavItem
        label="Logs"
        icon={<NotesIcon />}
        level1Labels={["View"]}
        level1Icons={[<VisibilityIcon />]}
        level1Links={["/logs"]}
      />
      <NavItem
        label="Sales"
        icon={<SellIcon />}
        level1Labels={["Applicants", "Demo Signups", "Promo Codes"]}
        level1Icons={[<ApprovalIcon />, <GamesIcon />, <UpgradeIcon />]}
        level1Links={["/applicants", "/demos", "/orgs"]}
      />
      <NavItem
        label="Dev"
        icon={<CodeIcon />}
        level1Labels={[
          "Messages",
          "Webhooks",
          "Access keys",
          "Secure Downloads",
        ]}
        level1Icons={[
          <MessageIcon />,
          <PhyishingIcon />,
          <KeyIcon />,
          <DownloadIcon />,
        ]}
        level1Links={["/messages", "/webhooks", "/accessKeys", "/downloads"]}
      />

<NavItem
        label="Admin Users"
        icon={<VerifiedUserIcon />}
        level1Labels={[
          "View",
          "Add",
        ]}
        level1Icons={[
          <VisibilityIcon />,
          <AddIcon />,
        ]}
        level1Links={["/admin_users", "/admin_register_new_user"]}
      />

    </List>
  );
}
